// New copy structure for Hola Spanglish

export const heroDataNew = {
  headline: "Personalized Spanish Coaching with an Argentine Touch",
  subheadline:
    "Build confidence, fluency, and real-life conversational skills through personalized Spanish sessions designed around your goals, lifestyle, and learning rhythm.",
  ctaPrimary: "Explore Programs",
  ctaSecondary: "Book Your First Session",
  image: "https://images.unsplash.com/photo-1673515336170-3bf951ddb5a8"
};

export const whyStudentsData = {
  title: "Why Students Love Hola Spanglish",
  subtitle: "An authentic, flexible and student-centered coaching experience",
  benefits: [
    {
      icon: "UserRound",
      title: "Personalized private coaching",
      description: "Every session is built around your goals, level and pace."
    },
    {
      icon: "CalendarClock",
      title: "Flexible scheduling",
      description: "Use your sessions when they fit your life — weekly or in sprints."
    },
    {
      icon: "MessagesSquare",
      title: "Conversational Spanish",
      description: "Focused on real-life communication, not memorized phrases."
    },
    {
      icon: "Globe2",
      title: "Argentine culture & lifestyle immersion",
      description: "Learn the language alongside the rhythm, slang and culture."
    },
    {
      icon: "Heart",
      title: "Supportive learning environment",
      description: "Relaxed, judgment-free space designed to help you speak more."
    },
    {
      icon: "Sparkles",
      title: "For every level",
      description: "Designed for beginners, travelers, professionals and advanced learners."
    }
  ]
};

export const programsData = {
  title: "Programs",
  subtitle: "Choose the coaching experience that fits your goals and schedule",
  plans: [
    {
      id: "starter",
      name: "STARTER",
      tagline: "Try the Hola Spanglish experience",
      description:
        "Perfect for students who want to explore the method before committing long-term.",
      price: 225,
      currency: "USD",
      sessions: "5 private sessions",
      validity: "Valid for 1 month",
      features: [
        "5 private sessions",
        "Valid for 1 month",
        "Flexible scheduling",
        "Personalized learning plan",
        "Conversational Spanish practice"
      ],
      cta: "Start Now",
      featured: false
    },
    {
      id: "momentum",
      name: "MOMENTUM",
      tagline: "Build consistency and confidence",
      description:
        "Designed for students who want to create a steady Spanish routine and improve naturally through conversation.",
      price: 645,
      currency: "USD",
      sessions: "15 private sessions",
      validity: "Valid for 3 months",
      features: [
        "15 private sessions",
        "Valid for 3 months",
        "Flexible session usage",
        "Personalized conversation topics",
        "Vocabulary & fluency support"
      ],
      cta: "Start Now",
      featured: false
    },
    {
      id: "immersion",
      name: "IMMERSION",
      tagline: "A deeper Spanish experience",
      description:
        "Ideal for committed learners looking for faster progress and deeper immersion in the language and culture.",
      price: 1230,
      currency: "USD",
      sessions: "30 private sessions",
      validity: "Valid for 6 months",
      features: [
        "30 private sessions",
        "Valid for 6 months",
        "Conversational immersion",
        "Pronunciation & confidence coaching",
        "Personalized learning experience",
        "Flexible scheduling"
      ],
      cta: "Start Now",
      featured: true
    },
    {
      id: "fluency",
      name: "FLUENCY JOURNEY",
      tagline: "Long-term transformation",
      description:
        "For students who are serious about achieving real conversational fluency and integrating Spanish into their daily lives.",
      price: 2400,
      currency: "USD",
      sessions: "60 private sessions",
      validity: "Valid for 12 months",
      features: [
        "60 private sessions",
        "Valid for 12 months",
        "Fully personalized coaching",
        "Long-term progress tracking",
        "Priority scheduling",
        "Advanced conversational practice"
      ],
      cta: "Start Now",
      featured: false
    },
    {
      id: "elite",
      name: "ELITE",
      tagline: "The complete Hola Spanglish experience",
      description:
        "A premium long-term coaching experience for intensive learners, professionals, and students preparing for important goals.",
      price: 4560,
      currency: "USD",
      sessions: "120 private sessions",
      validity: "Valid for 24 months",
      features: [
        "120 private sessions",
        "Valid for 24 months",
        "Maximum scheduling flexibility",
        "Premium scheduling priority",
        "Advanced conversation coaching",
        "Lifestyle & cultural immersion",
        "DELE & school exam preparation",
        "Personalized study support",
        "Custom learning roadmap"
      ],
      cta: "Start Now",
      featured: false
    }
  ]
};

export const flexibilityData = {
  title: "Flexible Learning Experience",
  description:
    "Students may use their sessions at their own pace within the validity period of their program.",
  examples: [
    "1 session per week",
    "2–3 sessions per week",
    "Intensive short-term immersion"
  ],
  closing:
    "Each program is designed to adapt to different lifestyles, schedules, and learning goals."
};

export const addOnsData = {
  title: "Optional Add-Ons",
  subtitle: "Tailor your program with extra coaching support",
  addOns: [
    {
      id: "dele",
      name: "DELE Prep Add-On",
      description:
        "Personalized support for students preparing for DELE exams.",
      includes: [
        "Mock oral exams",
        "Writing corrections",
        "Pronunciation feedback",
        "Exam strategies",
        "Personalized study guidance"
      ],
      price: "USD 80–150 / month"
    },
    {
      id: "school",
      name: "School Support Add-On",
      description:
        "Academic support for middle school, high school, and college Spanish students.",
      includes: [
        "Homework support",
        "Test preparation",
        "Grammar review",
        "Writing corrections",
        "Vocabulary reinforcement"
      ],
      price: "USD 60–120 / month"
    },
    {
      id: "sprint",
      name: "Intensive Exam Sprint",
      description:
        "Short-term intensive coaching for upcoming exams, presentations, or academic goals.",
      includes: [
        "Intensive weekly sessions",
        "Personalized preparation",
        "Short-term focused support"
      ],
      price: "Custom pricing available"
    }
  ]
};

export const howItWorksData = {
  title: "How It Works",
  steps: [
    {
      number: "01",
      title: "Choose Your Program",
      description:
        "Select the learning experience that best fits your goals and schedule."
    },
    {
      number: "02",
      title: "Book Your Sessions",
      description:
        "Schedule your sessions flexibly throughout your program period."
    },
    {
      number: "03",
      title: "Learn at Your Own Pace",
      description:
        "Use your sessions weekly or intensively depending on your needs."
    },
    {
      number: "04",
      title: "Build Confidence in Spanish",
      description:
        "Develop real conversational fluency through personalized coaching and immersion."
    }
  ]
};

export const guidelinesData = {
  title: "Student Guidelines",
  subtitle: "Clear and fair policies so you can focus on learning",
  items: [
    {
      title: "Session Validity",
      lines: [
        "Sessions must be used within the validity period of each program.",
        "Unused sessions do not roll over after the program expires."
      ]
    },
    {
      title: "Rescheduling",
      lines: [
        "Sessions may be rescheduled with at least 24 hours' notice.",
        "Late cancellations may be counted as completed sessions."
      ]
    },
    {
      title: "Returning Student Upgrade",
      lines: [
        "Students who begin with the STARTER program and choose to continue into a longer program may receive a special returning student discount."
      ]
    }
  ]
};

export const finalCtaData = {
  title: "Ready to Start Your Spanish Journey?",
  subtitle:
    "Experience personalized Spanish coaching designed around your goals, rhythm, and lifestyle.",
  ctaPrimary: "Join Hola Spanglish",
  ctaSecondary: "Book Your First Session"
};
